import StepSelectDocumentType from '@/febos/chile/dnt/components/wizard/customDocuments/StepSelectDocumentType';

export default () => ({
    currentStep: 0,
    steps: [
      {
        title: 'Crear Documento Nuevo',
        component: StepSelectDocumentType
      }
    ],
    options: ['submit'],
    displayNextTitle: false,
    submitAction: 'navigateToForm',
    backupAction: null,
    loadAllData: false,
    fromStorage: false,
    wizardMapper(data) {
      return data || {};
    },
    documentMapper(input) {
      const data = {
        dnt: {
          tipo: 'EXP',
          tipoFlujo: 1, // ingreso (1), salida (2) e interno (3)
          origen: input.origin,
          emisorRut: iutCompany,
          receptorRut: iutCompany,
          emisorRazonSocial: nameCompany,
          receptorRazonSocial: nameCompany,
          claseMercadoPublico: 'ext',
          documentType: input && input.documentType ? input.documentType : null,
          emisorCentroCostoNumero: input.documentType,
          emisorSucursalPais: input.documentTypeId,
          emisorCentroCostoNombre: input.documentTypeName,
          emisorContactoCodigo: input.documentCode,
          emisorContactoNombre: input.senderName,
          emisorContactoEmail: input.senderEmail,
          emisorContactoTelefono: input.senderPhone,
          emisorSucursalCodigo: input.process,
          emisorSucursalDireccion: input.subProcess,
          transportePuertoNombre: input.processName,
          transportePuertoPais: input.subProcessName,
          estado: input.isExternal ? 1 : 2,
        },
        destinatarios: [
          ...(input.subjectsSelected || []).map((subject) => ({
            tipoDestino: 1,
            estado: 1,
            destinoCodigoId: subject.subjectType.id,
            destinoCodigo: subject.subjectType.value,
            destinoNombre: subject.subjectType.label,
            destinoListaCodigoId: subject.subject.id,
            destinoListaCodigo: subject.subject.value,
            destinoListaNombre: subject.subject.label,
            destinoCorreo: subject.subjectEmail,
            providenciaId: subject.providence,
            providenciaVencimiento: subject.providenceExpiration,
          })),
          ...(input.copiesSelected || []).map((subject) => ({
            tipoDestino: 2,
            estado: 1,
            destinoCodigoId: subject.copySubjectType.id,
            destinoCodigo: subject.copySubjectType.value,
            destinoNombre: subject.copySubjectType.label,
            destinoListaCodigoId: subject.copySubject.id,
            destinoListaCodigo: subject.copySubject.value,
            destinoListaNombre: subject.copySubject.label,
            destinoCorreo: subject.copySubjectEmail,
            providenciaId: subject.providence,
            providenciaVencimiento: subject.providenceExpiration,
          }))
        ],
        referencias: (input.relatedDocumentsSelected || []).map((relatedDocument) => ({
          linea: relatedDocument.id,
          tipoDocumento: relatedDocument.type,
          folio: relatedDocument.number
        })),
      };
      if (input.solicitanteDocumentoId) {
        data.dnt.solicitanteRut = input.solicitanteRut;
        data.dnt.solicitanteNombre = input.solicitanteNombre;
        data.dnt.solicitanteEmail = input.solicitanteEmail;
        data.dnt.solicitanteDocumentoId = input.solicitanteDocumentoId;
      }
      console.log('DATA'. data);
      return;
      return data;
    }
});
